module.exports = __webpack_public_path__ + "img/k.70c7f228.jpg";